export const eraseFromLocalStorage = (key: string) => {
  localStorage.removeItem(key)
}
